export default __webpack_public_path__ + "static/0132-c1c98c529d6ac183fbb60cd54671e4d5.png";